/*
* 同意状態管理システム
* 同意状態の管理と送信ボタン制御を担当
*/
import FormValidator from './FormValidator.js';

export default class ConsentStateManager {
  constructor() {
    // 同意状態の管理
    this.consentStates = {
      investor: new Map(), // linkId -> boolean
      privacy: false,
      general: false // 一般的な同意（利用規約など）
    };

    // フォーム検証
    this.formValidator = new FormValidator();
  }

  // 他のモジュールと同じパターンで初期化
  attachEvent() {
    // DOM要素の取得
    this.checkConsentButton = document.querySelector('[data-target="checkConsentButton"]');
    this.privacyCheckbox = document.querySelector('.privacy-consent-checkbox');
    this.generalCheckbox = document.querySelector('[data-target="checkConsent"]');
    this.investorConsents = document.querySelectorAll('[data-target="investorRegistrationModal"], [data-target="investorRegistrationLink"]');

    // 初期化
    this.initializeConsentStates();
    this.setupEventListeners();
    this.formValidator.initialize();

    // 初期状態を設定（わずかに遅延させてDOM要素が確実に存在するようにする）
    setTimeout(() => {
      this.updateSubmitButton();
    }, 100);
  }

  // 初期状態を内部状態に反映
  initializeConsentStates() {
    // プライバシー同意の初期状態
    if (this.privacyCheckbox) {
      this.consentStates.privacy = this.privacyCheckbox.checked;
    }

    // 一般的な同意の初期状態
    if (this.generalCheckbox) {
      this.consentStates.general = this.generalCheckbox.checked;
    }

    // 投資家同意の初期状態（サーバーサイドの状態を反映）
    Array.from(this.investorConsents).forEach(item => {
      const linkId = item.getAttribute('data-link-id');
      const isChecked = item.classList.contains('is-checked');
      if (linkId) {
        this.consentStates.investor.set(linkId, isChecked);
      }
    });
  }

  // イベントリスナーの設定
  setupEventListeners() {
    // CustomEventによる同意状態変更の監視（統一）
    document.addEventListener('consent:changed', (event) => {
      this.handleConsentChange(event);
    });

    // 一般的な同意チェックボックスの直接監視
    if (this.generalCheckbox) {
      this.generalCheckbox.addEventListener('change', () => {
        this.consentStates.general = this.generalCheckbox.checked;
        this.updateSubmitButton();
      });
    }

    // フォーム検証状態変更の監視
    document.addEventListener('formValidation:changed', () => {
      this.updateSubmitButton();
    });
  }

  // 同意状態変更の処理
  handleConsentChange(event) {
    const { type, linkId, consented } = event.detail;

    if (type === 'privacy') {
      this.consentStates.privacy = consented;
    } else if (type === 'investor-modal' || type === 'investor-link') {
      if (linkId) {
        this.consentStates.investor.set(linkId, consented !== false);
      }
    }

    this.updateSubmitButton();
  }

  // 個人情報の取扱いについての同意の状態確認
  isPrivacyConsentChecked() {
    if (!this.privacyCheckbox) return true;
    return this.consentStates.privacy;
  }

  // 出資者情報登録の同意・承諾の状態確認
  areInvestorConsentsChecked() {
    if (this.investorConsents.length === 0) return true;

    return Array.from(this.investorConsents).every(item => {
      const linkId = item.getAttribute('data-link-id');
      return linkId && this.consentStates.investor.get(linkId) === true;
    });
  }

  // 一般的な同意の状態確認
  isGeneralConsentChecked() {
    if (!this.generalCheckbox) return true;
    return this.consentStates.general;
  }

  // 送信ボタンの状態更新（メインロジック）
  updateSubmitButton() {
    if (!this.checkConsentButton) return;

    const privacyConsentChecked = this.isPrivacyConsentChecked();
    const investorConsentsChecked = this.areInvestorConsentsChecked();
    const generalConsentChecked = this.isGeneralConsentChecked();
    const requiredFieldsFilled = this.formValidator.validate();

    // 全ての条件を満たす場合のみボタンを有効化
    this.checkConsentButton.disabled = !(
      privacyConsentChecked &&
      investorConsentsChecked &&
      generalConsentChecked &&
      requiredFieldsFilled
    );
  }

  // 他のモジュールから状態変更を通知されるためのメソッド（下位互換性）
  notifyStateChange() {
    this.updateSubmitButton();
  }
}
